import React, { useEffect, useState } from "react";
import Link from "next/link";

const ImageGallery: React.FC = () => {
  const [images, setImages] = useState<string[]>([]);

  const getRandomImages = (allImages: string[]) => {
    const shuffled = [...allImages].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 16);
  };

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch("/api/images");
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        const validImages = data.filter((src: string) => /\.(png|jpe?g|gif|webp)$/i.test(src));
        setImages(getRandomImages(validImages));
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
    const interval = setInterval(fetchImages, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-[var(--bg-surface-dk)] py-14 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-black text-[var(--color-text-brand)] text-center mb-2">
          Retreat Photo Gallery
        </h2>
        <p className="text-sm text-center text-[var(--text-on-light-muted)] mb-2">
          A glimpse into our transformative retreats
        </p>
        <p className="text-sm text-center text-[var(--text-on-light-muted)] mb-8">
          Share your memories —{" "}
          <Link
            href="mailto:retreats@cforganicwellness.com"
            className="text-[var(--color-text-brand)] underline underline-offset-2 hover:opacity-70"
          >
            email us your photos
          </Link>
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {images.map((src, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-xl aspect-square group shadow-sm"
            >
              <img
                src={src}
                alt={`Retreat moment ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 rounded-xl" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;
